'use strict';
const angular = require('angular');

export class inlineDropdownMenuComponent {
  /*@ngInject*/
  constructor() {
  }
}

export default angular.module('conduuApp.inlineDropdownMenu', [])
  .component('inlineDropdownMenu', {
    template: require('./inline-dropdown-menu.component.html'),
    bindings: {
      icon: '@',
      title: '@',
      menu: '<',
      context: '<'
    },
    controller: inlineDropdownMenuComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/inline-dropdown-menu/inline-dropdown-menu.component.js